import { useState, useEffect, useCallback } from 'react';
import { Bold, Flex } from './TremorCompat';
import { Panel, Slider, Text } from 'rsuite';

import { DisplayIcon } from './DisplayIcon';

const markLinkStyle = {
  fontSize: 10,
  fontWeight: 500,
  padding: '2px',
};

export const DisplayORPPhSensorOffsetSliderItem = ({
  register,
  tc,
  icon,
  min,
  max,
  step,
  onChange,
  disabled,
  ispH,
  borderOff,
}) => {
  const convertToSliderValue = useCallback(
    (theValue) => {
      if (!Number.isFinite(theValue)) {
        return min;
      }
      var aCalcValue = theValue - 30;
      var bcalcValue = aCalcValue;

      if (ispH) {
        bcalcValue = aCalcValue / 10;
        // console.log( "Ph Offset value: ", theValue," A :", aCalcValue, "b:", bcalcValue)
      } else {
        bcalcValue = aCalcValue * 10;
        // console.log( "ORP Offset value: ", theValue," A :", aCalcValue, "b:", bcalcValue)
      }
      return bcalcValue;
    },
    [ispH, min],
  );

  const [value, setValue] = useState(() => convertToSliderValue(register.value));
  const forMatValue = () => {
    return value;
  };

  const doSetValue = (newValue) => {
    if (ispH) {
      setValue(Number(newValue.toFixed(1)));
    } else {
      setValue(Number(newValue.toFixed(0)));
    }
  };

  const convertFromSliderValue = (sValue) => {
    var calcValue = sValue;
    if (ispH) {
      calcValue = calcValue * 10;
    } else {
      calcValue = calcValue / 10;
    }

    return calcValue + 30;
  };

  const updateValue = (value, event) => {
    const convertedValue = convertFromSliderValue(value);
    // if ( ispH)
    // {
    //   console.log( "Ph Offset converted from slider = ", convertedValue, event, value);
    // }
    // else
    // {
    //   console.log( "ORP Offset converted from slider = ", convertedValue, event, value);
    // }
    onChange(register, convertedValue);
  };

  useEffect(() => {
    setValue(convertToSliderValue(register.value));
  }, [register.value, convertToSliderValue]);

  return (
    <Panel bordered={!borderOff} style={{ backgroundColor: 'white' }}>
      <Flex justifyContent="start" className="space-x-4">
        <DisplayIcon icon={icon} />
        <div className="truncate space-y-1 w-1/2">
          <Text color={tc} className="truncate">
            {register.title}
          </Text>
          <Text color={tc} className="truncate">
            <Bold>{value}</Bold>
          </Text>
        </div>
        <div
          style={{
            display: 'block',
            width: '100%',
            paddingLeft: 10,
            paddingRight: 5,
            alignItems: 'flex-end',
            zIndex: 1,
          }}
        >
          <Slider
            progress
            barClassName="slideritem"
            min={min}
            max={max}
            step={step}
            value={value}
            onChange={doSetValue}
            onChangeCommitted={updateValue}
            renderTooltip={forMatValue}
            disabled={disabled}
            graduated
            renderMark={(mark) => {
              if (ispH) {
                if ((mark * 10) % 2 === 0 || [-1.5, 1.5].includes(mark)) {
                  return <span style={markLinkStyle}>{mark}</span>;
                }
              } else {
                if (mark % 20 === 0 || [-150, 150].includes(mark)) {
                  return <span style={markLinkStyle}>{mark}</span>;
                }
              }
              return null;
            }}
          />
        </div>
      </Flex>
    </Panel>
  );
};
